import Paragraph from "@vfuk/core-paragraph/";
import Span from "@vfuk/core-span";
import Container from "@vfuk/core-container";

const CustomerError = ({ error }: { error: string }) => (
  <Container appearance="primary" elevation>
    <Paragraph justify="center" size={2}>
      <Span appearance="secondary" weight={2}>
        {error}
      </Span>
    </Paragraph>
  </Container>
);

export default CustomerError;
